import { render, staticRenderFns } from "./Portrait.vue?vue&type=template&id=6b7ae595&"
import script from "./Portrait.vue?vue&type=script&lang=js&"
export * from "./Portrait.vue?vue&type=script&lang=js&"
import style0 from "./Portrait.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports